var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-no-wrap"},[(_vm.withIcon)?_c('v-switch',{class:_vm.iconStyles,attrs:{"input-value":_vm.value,"readonly":_vm.readonly,"color":_vm.color,"disabled":_vm.disabled,"true-value":"active","false-value":"inactive"},on:{"click":_vm.onClick}}):_vm._e(),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }